import { AudioAsset } from '~/models/Asset'
import { isText, isTransition } from '~/Util/assets'

export const isAvailableAttachTransition = asset => {
  if (!asset) return false
  return !(isText(asset.type)
  || isTransition(asset.type)
  || asset instanceof AudioAsset)
}
